import React, { useContext } from 'react'
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { Box,Button, Container, IconButton, TextField, Typography } from "@mui/material";
import { useNavigate } from 'react-router-dom';
import RtlProvider from '../../Components/RtlProvider';
import { ContextNotification, severitys } from '../../App';
import UserApi from '../../api/UserApi';
import { MdOutlineVisibility, MdOutlineVisibilityOff } from 'react-icons/md';
const ChangePassword = () => {
    const { open, setOpen } = useContext(ContextNotification);
    const [visiblePass, setVisiblePass] = React.useState(false);
    const [visibleRePass, setVisibleRePass] = React.useState(false);
    const navigate = useNavigate();
    const schema = yup.object().shape({
        oldPass: yup.string().required(" کلمه عبور قبلی را وارد نمایید"),
        newPass: yup.string().required(" کلمه عبور جدید را وارد نمایید"),
        newPassReply: yup.string().required("تکرار کلمه عبور جدید را وارد نمایید").oneOf([yup.ref('newPass'), null], 'کلمه عبور با تکرار آن متفاوت است'),

    });
    const { register, handleSubmit, formState: { errors } } = useForm({
        resolver: yupResolver(schema),
    });
    const renderErrorMessage = (errorCode) => {
        switch (errorCode) {

            case 'PasswordTooShort':
                return 'کلمه عبور بایستی حداقل 6 کاراکتر باشد';
            case 'PasswordRequiresLower':
                return 'کلمه عبور بایستی شامل حرف کوچک باشد';
            case 'PasswordRequiresUpper':
                return 'کلمه عبور بایستی شامل حرف بزرگ باشد';

            case 'PasswordRequiresNonAlphanumeric':
                return 'کلمه عبور بایستی شامل حروف غیر الفبایی باشد';
            case 'PasswordRequiresDigit':
                return 'کلمه عبور بایستی شامل عدد باشد';
            default:
                return '';
        }

    }
    const onSubmit = (data) => {


        if (data.newPassReply !== data.newPass)
            setOpen({ IsEnable: true, Message: 'کلمه عبور با تکرار آن متفاوت است', severity: severitys.error });
        else {

            UserApi.ChangePassword(data.oldPass,data.newPass,data.newPassReply)
                .then(() => {
                    setOpen({ IsEnable: true, Message: 'تغییر کلمه عبور با موفقیت اعمال شد', severity: severitys.Message })
                    localStorage.clear();
                   navigate('/login') ;
                })
                .catch((err) => {
                    var errmsg = '';
                    console.log(err);
                    if (err.response && err.response.data && err.response.data[0] && err.response.data[0].code) {
                        var code = err.response.data[0].code;
                        errmsg = renderErrorMessage(code);

                    }

                    if (err.response && err.response.data) {

                        setOpen({ IsEnable: true, Message: (errmsg !== '') ? errmsg : JSON.stringify(err.response.data), severity: severitys.error });
                    }
                    else if (err.response && err.response.data.errors) {

                        setOpen({ IsEnable: true, Message: (errmsg !== '') ? errmsg : JSON.stringify(err.response.data.errors), severity: severitys.error });
                    }
                    else if (err.message) {
                        setOpen({ IsEnable: true, Message: (errmsg !== '') ? errmsg : JSON.stringify(err.message), severity: severitys.error });
                    }
                    else
                        console.log(err)
                });



        }
    };

    return (
        <Container component="main" maxWidth="xs">
            <form onSubmit={handleSubmit(onSubmit)}>
                <RtlProvider>
                <div style={{ width: '100%' }}>
                    <Typography component="h1" variant="h5">
                        تغییر کلمه عبور
                    </Typography>
                    
                    <TextField  
                    id="outlined-basic" 
                    variant="outlined" 
                    type="password" 
                    {...register("oldPass")} 
                    fullWidth label="کلمه عبور قبلی " 
                    margin="normal"
                    error={!!errors.oldPass?.message}
                    helperText={errors.oldPass?.message}
                    />
                    {/* <p className="error">{errors.oldPass?.message}</p> */}
                
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                    <TextField  
                    id="outlined-basic" 
                    variant="outlined" 
                    type={visiblePass ? "text" : "password"} 
                    {...register("newPass")}  
                    fullWidth 
                    label="کلمه عبور جدید " 
                    margin="normal"
                    error={!!errors.newPass?.message}
                    helperText={errors.newPass?.message}
                    />
                    <IconButton onClick={() => { setVisiblePass(old => !old) }}>
                      {(visiblePass ? <MdOutlineVisibilityOff /> : <MdOutlineVisibility />)}
                      </IconButton>
                    {/* <p className="error">{errors.newPass?.message}</p> */}
                   </Box>
                   <Box sx={{ display: "flex", alignItems: "center" }}>
                    <TextField  
                    id="outlined-basic" 
                    variant="outlined" 
                    type={visibleRePass ? "text" : "password"} 
                    {...register("newPassReply")}   
                    fullWidth 
                    label="تکرار کلمه عبور جدید " 
                    margin="normal"
                    error={!!errors.newPassReply?.message}
                    helperText={errors.newPassReply?.message}
                    />
                    <IconButton onClick={() => { setVisibleRePass(old => !old) }}>
                      {(visibleRePass ? <MdOutlineVisibilityOff /> : <MdOutlineVisibility />)}
                      </IconButton>
                    {/* <p className="error">{errors.newPassReply?.message}</p> */}
                    </Box>
                </div>
                    <Button type="submit" variant="contained" color="secondary" fullWidth>تغییر کلمه عبور</Button>
                </RtlProvider>
            </form>
        </Container>
    )
}
export default ChangePassword;